import styles from './sessionexpire.css';
import Icon from '../icon/icon.js';
import { doLogout } from '../../../src/api/api.js';

export function displaySessionExpireInfo(logoutLink, trans) {
  const cookieDisabledInfo = document.querySelector('#cookie-disabled-info');
  if (cookieDisabledInfo === null) {
    const foo = document.querySelector('body');
    const helper = document.createElement('div');
    const valList = `<div id="cookie-disabled-info" class="${styles.modalWrapper__show}">
      <div class="${styles.modalDialog}">
        <div class="${styles.modalBody}">
          <span role='icon'>
            <i>${Icon('informationCircle')}</i>
          </span>
          <div class="${styles.sessionExpired}">
            ${trans['session-expired']}
          </div>
          <div class="${styles.clickReturnToLogin}">
            ${trans['click-return-login']}
          </div>
          <div class="${styles.btnSection}">
            <button id="backToLogin" tabindex='0'>
              ${trans['back-to-login']}
            </button>
          </div>
        </div>
      </div>
    </div>`;
    helper.innerHTML = valList;
    while (helper.firstChild) {
      foo.appendChild(helper.firstChild);
    }
    const backToLogin = document.querySelector('#backToLogin');
    if (backToLogin) {
      backToLogin.addEventListener('click', () => {
        doLogout(logoutLink);
      });
    }
  }
}

export default displaySessionExpireInfo;
